exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".image-container {\n  float: left;\n  width: 50px; }\n\n.text-container {\n  padding-top: 3px;\n  height: 24px; }\n\n.subitem-image {\n  margin-left: -2em;\n  margin-right: 14px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/sidebar/sidebar.component.scss
// module id = 1105
// module chunks = 7